import { el } from '@/ui/dom';

/**
 * onlineWaiting.ts (M115) — the shared "waiting for the others to finish" body.
 *
 * Owner round: "ensure we enhance the screen the user sees when they Skip and
 * are waiting for others to finish to match current design of menus and
 * screens etc." The old version was three bare lines (kicker, title, one
 * sentence) in a language nothing else in the game uses any more.
 *
 * TWO screens show this moment — the quick-race results waiting room and the
 * tour intermission's — so the body lives here once and both call it. They
 * used to be hand-copied and had already drifted apart ("FINISHED!" vs "RACE
 * COMPLETE" over identical copy).
 *
 * The language is the M65 editorial one the rest of the menus use: a gold
 * rule-flanked kicker, a chrome display title, then a glass module. The
 * pulsing dots exist so the screen reads as WAITING rather than STUCK — the
 * complaint that started this round was a screen that looked frozen.
 */
export function buildWaitingBody(
  panel: HTMLElement,
  kickerText: string,
  title: string,
  lead: string,
): void {
  const kicker = el('div', 'lb-kicker', panel);
  el('span', 'mhead-rule', kicker);
  el('span', 'lb-kicker-text', kicker).textContent = kickerText;
  el('span', 'mhead-rule', kicker);

  const h = el('div', 'lb-title wait-title', panel);
  h.textContent = title;
  h.dataset.text = title; // the chrome logotype's extruded edge reads this

  const card = el('div', 'wait-card', panel);
  const dots = el('div', 'wait-dots', card);
  for (let i = 0; i < 3; i++) {
    el('span', 'wait-dot', dots).style.setProperty('--i', String(i));
  }
  el('div', 'wait-lead', card).textContent = lead;
  // Reassurance, not decoration: a player who skipped out of spectating needs
  // to know their own result is already safe.
  el('div', 'wait-note', card).textContent =
    'YOUR RESULT IS LOCKED IN — STANDINGS APPEAR THE MOMENT THE RACE IS DECIDED';
}
